export function getLiteralsRegistroPage(t: any) {
  return {
    title: t("literals.registroPage.title"),
    desc: t("literals.registroPage.desc"),
    input: { maintext: t("literals.registroPage.input.maintext") },
    button: t("literals.registroPage.button"),
    messagesError: {
      invalidField: {
        maintext: t(
          "literals.registroPage.messagesError.invalidField.maintext"
        ),
      },
    },
    toast: {
      success: {
        title: t("literals.registroPage.toast.success.title"),
        desc: t("literals.registroPage.toast.success.desc"),
      },
      errorExists: {
        title: t("literals.registroPage.toast.errorExists.title"),
        desc: t("literals.registroPage.toast.errorExists.desc"),
      },
      errorTryLater: {
        title: t("literals.registroPage.toast.errorTryLater.title"),
        desc: t("literals.registroPage.toast.errorTryLater.desc"),
      },
    },
  };
}

export function getChecksRegisterModalLiterals(t: any) {
  return {
    headerModal: t("checksRegisterModal.headerModal"),
    description: {
      template: t("checksRegisterModal.description.template"),
      keys: [
        {
          type: "link",
          text: t("checksRegisterModal.description.linkPolicyPlatform"),
          id: "linkPolicyPlatform",
          href: t("url.privacyPolicy"),
        },
        {
          type: "bold",
          text: t("checksRegisterModal.description.boldPayAtention"),
          id: "boldPayAtention",
        },
      ],
    },
    checks: [
      {
        template: t("checksRegisterModal.checks.termsAndPolicy.template"),
        id: "termsAndPolicy",
        keys: [
          {
            type: "link",
            text: t("checksRegisterModal.checks.termsAndPolicy.terms"),
            id: "terms",
            href: t("url.termsConditions"),
          },
          {
            type: "link",
            text: t("checksRegisterModal.checks.termsAndPolicy.policy"),
            id: "policy",
            href: t("url.privacyPolicy"),
          },
        ],
        required: true,
        value: false,
      },
      {
        id: "age",
        template: t("checksRegisterModal.checks.age.template"),
        required: true,
        value: false,
      },
      {
        id: "comercial-communications",
        template: t(
          "checksRegisterModal.checks.comercial-communications.template"
        ),
        required: false,
        value: false,
      },
      {
        id: "personal-data-sharing",
        template: t(
          "checksRegisterModal.checks.personal-data-sharing.template"
        ),
        required: false,
        value: false,
      },
      {
        id: "profile-custom-experience",
        template: t(
          "checksRegisterModal.checks.profile-custom-experience.template"
        ),
        required: false,
        value: false,
      },





    ],
    buttonsFooter: [
      {
        text: t("checksRegisterModal.buttonsFooter.cancel"),
        style: "outline",
        id: "cancel",
      },
      {
        text: t("checksRegisterModal.buttonsFooter.continue"),
        style: "primary",
        id: "continue",
      },
    ],
  };
}

export function confirmMailLiterals(t: any): any {
  return {
    title: t("confirmMailLiterals.title"),
    changeEmail: t("confirmMailLiterals.changeEmail"),
    desc1: t("confirmMailLiterals.desc1"),
    desc2: t("confirmMailLiterals.desc2"),
    confirmmail1: t("confirmMailLiterals.confirmmail1"),
    confirmmail2: t("confirmMailLiterals.confirmmail2"),
    buttonmail: {
      openYourMail: t("confirmMailLiterals.buttonmail.openYourMail"),
      verifyYourAccount: t("confirmMailLiterals.buttonmail.verifyYourAccount")
    },
    verificationCodeText: t("confirmMailLiterals.verificationCodeText"),
  };
}

export function passValidationLiterals(t: any) {
  return {
    title: t("passValidationLiterals.title"),
    desc: t("passValidationLiterals.desc"),
    passval: {
      chars: t("passValidationLiterals.passval.chars"),
      upper: t("passValidationLiterals.passval.upper"),
      lower: t("passValidationLiterals.passval.lower"),
      number: t("passValidationLiterals.passval.number"),
      special: t("passValidationLiterals.passval.special"),
      message: {
        maintext: t("passValidationLiterals.passval.message.maintext"),
      },
      input: {
        maintext: {
          maintext: t("passValidationLiterals.passval.input.maintext.maintext"),
        },
      },
    },
    button: t("passValidationLiterals.button"),
  };
}

export function registerUserLiterals(t: any) {
  return {
    title: t("registerUserLiterals.title"),
    desc: t("registerUserLiterals.desc"),
    input: { maintext: t("registerUserLiterals.input.maintext"), },
    button: t("registerUserLiterals.button"),
    messagesError: {
      invalidField: { maintext: t("registerUserLiterals.messagesError.invalidField.maintext"), }
    }
  };
}
